/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ConsumableGroup from './consumable-group';
import ConsumableGroupDetail from './consumable-group-detail';
import ConsumableGroupUpdate from './consumable-group-update';
import ConsumableGroupDeleteDialog from './consumable-group-delete-dialog';

const ConsumableGroupRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ConsumableGroup />} />
    <Route path="new" element={<ConsumableGroupUpdate />} />
    <Route path=":id">
      <Route index element={<ConsumableGroupDetail />} />
      <Route path="edit" element={<ConsumableGroupUpdate />} />
      <Route path="delete" element={<ConsumableGroupDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ConsumableGroupRoutes;
